const TILES = [
  {
    src: "/images/werkstatt/steinschlag_nah.jpg",
    alt: "Massiver Steinschlag-Schaden auf Windschutzscheibe — echter Kundenfall bei Servus Autoglas Ludwigshafen",
    label: "Echter Kundenfall: Scheibenbruch",
  },
  {
    src: "/images/werkstatt/ferrari_sq.jpg",
    alt: "Ferrari in der Autoglas-Werkstatt von AutoGlas Erol in Ludwigshafen — Premium-Service",
    label: "Premium — auch für Sportwagen",
  },
  {
    src: "/images/werkstatt/cabrio.jpg",
    alt: "Cabrioverdeck mit beschädigter Heckscheibe — Reparatur durch Autosattlerei Erol Ludwigshafen",
    label: "Cabrioverdecke & Heckscheiben",
  },
  {
    src: "/images/werkstatt/wuerth_kleber.jpg",
    alt: "Original Würth Scheibenklebstoff Expert — Qualitätsmaterial für sichere Verklebung",
    label: "Original Würth Klebstoff",
  },
];

export const WerkstattGallery = () => (
  <section id="werkstatt-einblicke" className="py-16 md:py-24 bg-slate-900">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <p className="text-xs font-semibold text-blue-400 uppercase tracking-widest">Echte Einblicke</p>
        <h2 className="text-3xl md:text-4xl font-bold text-white mt-3 tracking-tight">
          Direkt aus unserer Werkstatt
        </h2>
        <p className="mt-4 text-slate-400 leading-relaxed">
          Keine Stock-Fotos: So arbeiten wir wirklich — vom Steinschlag-Totalschaden bis zum
          Premium-Sportwagen, mit Original-Material in Meisterqualität.
        </p>
      </div>

      <div
        className="mt-10 grid grid-cols-2 lg:grid-cols-4 auto-rows-[170px] md:auto-rows-[210px] gap-3 md:gap-4"
        data-testid="werkstatt-gallery"
      >
        <div className="col-span-2 row-span-2 relative rounded-2xl overflow-hidden border border-slate-700 group">
          <video
            ref={(el) => {
              if (el) {
                el.muted = true;
                const p = el.play();
                if (p) p.catch(() => {});
              }
            }}
            src="/videos/werkstatt.mp4"
            poster="/images/werkstatt/video_poster.jpg"
            onClick={(e) => (e.currentTarget.paused ? e.currentTarget.play() : e.currentTarget.pause())}
            className="w-full h-full object-cover cursor-pointer"
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
            data-testid="werkstatt-video"
          />
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-slate-950/80 to-transparent p-4 pointer-events-none">
            <span className="text-white text-sm font-semibold">Live aus der Werkstatt — Frankenthaler Str. 98</span>
          </div>
        </div>

        {TILES.map((t) => (
          <div key={t.src} className="relative rounded-2xl overflow-hidden border border-slate-700 group">
            <img
              src={t.src}
              alt={t.alt}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-slate-950/80 to-transparent p-3 pointer-events-none">
              <span className="text-white text-xs font-semibold">{t.label}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WerkstattGallery;
